<div class="section">
    <div class="container">


        <div class="row">


            <div class="col-md-8 col-sm-8 ml-auto mr-auto">
                <h4 class="title">
                    <small>Protection of Personal Information (POPI) Act 4 of 2013 Documentation</small>
                </h4>
                <div class="table-responsive mt-2">
                    <table class="table">

                        <tbody>
                            <tr *ngFor="let row of Data">

                            
                                <td> <a clickable class="" (click)="downloadFile(row._id, row.filename)">
                                        <img style="width: 50px;" class=" img-responsive" src="./assets/img/brand/pdf.png"></a></td>
                                        <td style="width: 100%;">{{row.name}}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="mt-5">
                Contact us on 0860 018 363 for any support enquiry.

            </div>
            </div>



            


        </div>

    </div>
</div>